// src/services/firebase.js
// ─────────────────────────────────────────────────────────────
// INSTRUÇÕES DE CONFIGURAÇÃO:
// 1. Acesse https://console.firebase.google.com
// 2. Crie um novo projeto (ex: "financas-pessoais")
// 3. Vá em "Configurações do projeto" > "Seus apps" > adicione um app Web
// 4. Copie as credenciais e substitua os valores abaixo
// 5. No console Firebase, ative:
//    - Authentication > Sign-in method > E-mail/senha
//    - Firestore Database > Criar banco de dados (modo produção)
// ─────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey:             "AIzaSyDmFeh7eXa7r40QWysFftMClW5Y5bsowxo",
  authDomain:        "kaiogastos-72163.firebaseapp.com",
  projectId:         "kaiogastos-72163",
  storageBucket:     "kaiogastos-72163.firebasestorage.app",
  messagingSenderId: "336497548164",
  appId:             "1:336497548164:web:95bf89db27fe72cd945bd1",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db   = getFirestore(app);
export default app;
